import { Component } from '@angular/core';

@Component({
  selector: 'app-pillar-1',
  imports: [],
  templateUrl: './pillar-1.component.html',
  styleUrl: './pillar-1.component.scss'
})
export class Pillar1Component {

}
